import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { withRouter } from 'react-router-dom';
import merge from 'lodash/merge';
import { showModal } from '../../../actions/shared/modal';
import BottomToolbar from '../../common/BottomToolbar';
import Button from '../../common/Button';
import ButtonLink from '../../common/ButtonLink';
import { getBestFilterId, getBestFilterName } from './plpFilter';
import { setNextFacets } from '../../../actions/shared/facets';
import queryUtil from '../../../modules/ajio-util/query';
// import StoreCategories from "../banner/StoreCategories";
import productsUtil, { parseProductQueryString, stringifyFacets } from '../../../utils/products';
import { toggleStoreNav } from '../../../actions/webMetaData';
import Icon from '../../../refresh/atoms/Icon';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { getAjioSuperCashPlpEnable } from '../../../refresh/selectors/featureFlagsSelector';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
// import BottomStrip from '../../../refresh/organism/BottomStrip';

class Filter extends React.Component {
  getFacetsQuery() {
    const { facetsquery } = this.props;
    if (Object.keys(facetsquery).length) {
      return stringifyFacets(merge({}, facetsquery));
    }
    return null;
  }

  render() {
    const {
      location = {},
      pushToHistory,
      facetsquery,
      getFiltersApplied,
      metaData,
      metaData: { showStoreNav = false },
      sortByName,
      initSortSelection,
      isOffline,
      bestFilterId,
      bestFilterName,
      luxeFlags,
      currentStore,
      ajioSuperCashPLPEnable = false,
      perfExperiments2513
    } = this.props;

    console.log('currentStore', currentStore);

    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && currentStore === 'luxe';
    const fleek = String(currentStore).toLowerCase() === 'ajiogram';
    const appliedFilters = getFiltersApplied() || [];
    const queryString = queryUtil.parseSearch(location.search) || {};
    const query = {
      ...queryString,
      ...parseProductQueryString(queryString.query || '')
    };
    let { viewType, facets, sortBy } = query;
    const { productToggle = '' } = this.props;
    const { sis = false } = metaData;
    if (viewType == null || viewType == undefined) {
      if (productToggle) {
        if (productToggle == 'TOGGLE_ON_PRODUCT') viewType = 'productview';
      } else {
        viewType = 'outfitview';
      }
    }
    const facetsQuery = productsUtil.parseFacets(facets);
    const isFacetSelected = Object.keys(facetsQuery).length > 0;
    // ${sis ? "sis-plp-product-filter": undefined}`}
    if (isOffline || !navigator.onLine) {
      return null;
    }

    const styleIcon = Object.freeze({
      fontSize: '1.6rem',
      color: 'white'
    });

    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreen;

    const showBottomStrip = currentStore !== 'luxe' &&  currentStore !== 'ajiogram' && ajioSuperCashPLPEnable;

    return (
      <>
        <BottomToolbar className="rilrtl-toolbar--products-filter sortFilterBox">
          <Button
            seconday
            modifier={['view', viewType]}
            style={fleek ? { background : "#1B1F23" } : {}}
            onClick={() => {
              const facets = this.getFacetsQuery();
              if (viewType == 'productview') {
                pushToHistory({ viewType: 'outfitview', facets });
              } else {
                pushToHistory({ viewType: 'productview', facets });
              }
            }}
          >
            <i />
          </Button>
          <ButtonLink
            to={location}
            seconday
            store={luxe ? 'luxe' : null}
            modifier="filter"
            className={bestFilterId ? (luxe?'oneby3-luxe':'oneby3') : 'oneby2'}
            style={fleek ? { background : "#1B1F23" } : {}}
            onClick={(e) => {
              const handleFilterClick = () => {
                const { location = {} } = this.props;
                const queryString = queryUtil.parseSearch(location.search) || {};
                if (Object.keys(queryString).length) {
                  const query = parseProductQueryString(queryString.query || '');
                  const { facets } = query;
                  const facetsQuery = productsUtil.parseFacets(facets);
                  this.props.setNextFacets(facetsQuery);
                }
                this.props.updateFilterModal(true);
                this.props.history.push({ ...location, hash: '#filterBy' });
                if (luxe) {
                  gtmEventPush({
                    event: 'plp_filter_menu_open',
                    event_category: 'product list interactions',
                    event_action: 'filter menu open',
                    store_type: currentStore,
                    page_name: screenName,
                    page_type: screenType
                  });
                }
              };

              e.preventDefault();
              // perf-25-13: Use setTimeout to yield to main thread and allow browser to paint first
              if (perfExperiments2513) {
                setTimeout(handleFilterClick, 0);
              } else {
                handleFilterClick();
              }
            }}
            role="button"
            ariaLabel={luxe ? 'APPLY FILTER' : 'APPLY FILTERS'}
          >
            <span className="filter-icon-space">
              {luxe ? (
                <Icon ariaHidden={true} icon="luxe-Filter" styles={{ fontSize: '24px', fontWeight: 'normal' }} />
              ) : (
                <Icon ariaHidden={true} icon="icon-Filter" styles={{ fontSize: '1.6rem', fontWeight: 'normal' }} />
              )}
            </span>
            <span className="button-text--products-filter" aria-hidden="true"><strong>{luxe ? 'FILTER' : 'FILTERS'}</strong></span>
            <span
              className={
                luxe
                  ? `button-text-icon--products-luxe-filter  ${
                      appliedFilters.includes('facets') && isFacetSelected ? '' : 'icon-hidden'
                    }`
                  : `button-text-icon--products-filter  ${
                      appliedFilters.includes('facets') && isFacetSelected ? '' : 'icon-hidden'
                    } ${fleek ? 'fleek-icon-filter' : ''}`
              }
            >
              .
            </span>
          </ButtonLink>
          <div className={luxe ? 'luxe-line-gap' : 'line-gap'} />
          {bestFilterId ? (
            <>
              <Button
                seconday
                modifier={['view', viewType]}
                style={fleek ? { background : "#1B1F23" } : {}}
                onClick={() => {
                  const facets = this.getFacetsQuery();
                  if (viewType == 'productview') {
                    pushToHistory({ viewType: 'outfitview', facets });
                  } else {
                    pushToHistory({ viewType: 'productview', facets });
                  }
                }}
              >
                <i />
              </Button>
              <ButtonLink
                to={{ ...location, hash: '#filterBy' }}
                seconday
                store={luxe ? 'luxe' : null}
                modifier="filter"
                className={bestFilterId ? (luxe?'oneby3-luxe':'oneby3') : 'oneby2'}
                style={fleek ? { background : "#1B1F23" } : {}}
                onClick={() => {
                  const { location = {} } = this.props;
                  const queryString = queryUtil.parseSearch(location.search) || {};
                  if (Object.keys(queryString).length) {
                    const query = parseProductQueryString(queryString.query || '');
                    const { facets } = query;
                    const facetsQuery = productsUtil.parseFacets(facets);
                    this.props.setNextFacets(facetsQuery);
                  }
                  this.props.updateCategoryModal(true);
                  if (luxe) {
                    gtmEventPush({
                      event: 'plp_category_menu_open',
                      event_category: 'product list interactions',
                      event_action: 'category menu open',
                      store_type: currentStore,
                      page_name: screenName,
                      page_type: screenType
                    });
                  }
                }}
                role="button"
                ariaLabel={luxe ? bestFilterName.toUpperCase() : bestFilterName}
              >
                <span className="button-text--products-filter">
                  <strong>{luxe ? bestFilterName.toUpperCase() : bestFilterName}</strong>
                </span>
              </ButtonLink>
              <div className={luxe ? 'luxe-line-gap' : 'line-gap'} />
            </>
          ) : null}
          <Button
            seconday
            store={luxe ? 'luxe' : null}
            modifier="sort"
            className={bestFilterId ? (luxe?'oneby3-luxe':'oneby3') : 'oneby2'}
            style={fleek ? { background : "#1B1F23" } : {}}
            onClick={() => {
              if (showStoreNav) {
                this.props.toggleStoreNav(showStoreNav);
              }
              this.props.showHideSortModal(true);
              if (luxe) {
                gtmEventPush({
                  event: 'plp_sort_menu_open',
                  event_category: 'product list interactions',
                  event_action: 'sort menu open',
                  store_type: currentStore,
                  page_name: screenName,
                  page_type: screenType
                });
              }
            }}
            ariaLabel={`Sort by ${sortByName || initSortSelection}`}
          >
            <div className="sort-section">
              {/* <span className={`button-text-icon--products-filter ${appliedFilters.includes("sortBy") ? "": ""}`} ></span> */}
              <span className="filter-icon-space">
                {luxe ? (
                  <Icon ariaHidden={true} icon="luxe-Sort" styles={{ fontSize: '24px', fontWeight: 'normal' }} />
                ) : (
                  <Icon ariaHidden={true} icon="icon-Sort" styles={styleIcon} />
                )}
              </span>
              <span className="button-text--products-filter" aria-hidden="true"><strong>SORT BY</strong></span>
            </div>
            {/* <div className="SortBySection">
                <div className="SortIcon">
                  <Icon icon="icon-Sort"  styles={styleIcon}/>
                </div>
                <div className="sortHeader">
                  <span className="button-text--products-filter" aria-label='SORT BY'>SORT BY</span> 
                  <span className="sortSelectedText">{sortByName ? sortByName : initSortSelection}</span>
                </div>
            </div> */}
          </Button>
          {/* {sis && <StoreCategories />} */}
        </BottomToolbar>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { productsAdditionalInfo = {}, facets = {}, metaData = {} } = state;
  const { productToggle = '' } = productsAdditionalInfo;
  const { currentFacets: { query: facetsquery = {} } = {} } = facets;
  const isOffline = _get(state, 'networkStatus.network') === 'OFFLINE';
  return {
    productToggle,
    facetsquery,
    metaData,
    isOffline,
    bestFilterId: getBestFilterId(state),
    bestFilterName: getBestFilterName(state),
    luxeFlags: getLuxeFlags(state.flags),
    currentStore: getCurrentStore(state),
    ajioSuperCashPLPEnable: getAjioSuperCashPlpEnable(state),
    perfExperiments2513: true,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: name => {
      dispatch(showModal(name));
    },
    setNextFacets: query => {
      dispatch(setNextFacets(query));
    },
    toggleStoreNav: showStoreNav => {
      dispatch(toggleStoreNav(showStoreNav));
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Filter));
